import './Section2AnchorComponent.css'
import comentarioIcon from './images/comentarios.png'
import preguntaIcon from './images/preguntas.png'
import unidosIcon from './images/unidos.png'
import { useState,useEffect } from 'react'

// function getWindowDimensions() {
//     const { innerWidth: width, innerHeight: height } = window;
//     return {
//       width,
//       height
//     };
//   }

export const Section2AnchorComponent = () => {
    // const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    const isOnBottom = () => {
        const body = window.document.body;
        return window.scrollY + window.innerHeight + 1 >= body.scrollHeight-20;
    }
    
    const [showAnchor, setShowAnchor] = useState(isOnBottom());
    

    const cambiarAnchor = (show) => {
        const anchors_container = window.document.getElementById('anchors-container');
        if(show) {
            anchors_container.classList.remove('m-fadeOut')
            anchors_container.classList.add('m-fadeIn')
        } else {
            anchors_container.classList.remove('m-fadeIn')
            anchors_container.classList.add('m-fadeOut')
        }
        setShowAnchor(show);
    }

    setInterval(()=>{if(isOnBottom()) {cambiarAnchor(false)}}, 10)

    useEffect(() => { 

        // function handleResize() {
        //   setWindowDimensions(getWindowDimensions());
        // }
        function handleScroll(ev) {
            
            if (isOnBottom() && showAnchor) {
                cambiarAnchor(false);
                    
            }else if(showAnchor) {
                cambiarAnchor(true);
            }
        }
    
        // window.addEventListener('resize', handleResize);
        window.addEventListener('scroll', handleScroll);

        // return (
        //     window.removeEventListener('resize', handleResize)
        // )
      }, []);

    return (
        <div id='anchors-container' className="fixed_bottom px-2 px-lg-0 anchor_mt anchors-container">
            <div className="d-flex justify-content-between w-100 rubik_regular blue_cl gap-2 text-center">


                <div className="anchor yellow_bg" onClick={ev => window.location = "#unidos"}>
                    <img src={unidosIcon} alt="Unidos a ti" />
                    <p className='m-0'>Unidos a ti</p>
                </div>

                <div className="anchor yellow_bg" onClick={ev => window.location = "#preguntas"}>
                    <img src={preguntaIcon} alt="Preguntas frecuentes" />
                    <p className='m-0'>Preguntas frecuentes</p>

                </div>

                <div className="anchor yellow_bg" onClick={ev => window.location = "#contactanos"}>
                    <img src={comentarioIcon} alt="Contactanos" />
                    <p className='m-0'>Contáctanos</p>
                </div>

            </div>
        </div>
    )
}